import React from 'react';
import { Group, Text } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { UntranslatedPlanNames } from '@landr/pricing';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';

const AddedToYourStudioPlan = () => {
    const { hasStudioPlan } = useUpsellActionsContext();

    if (!hasStudioPlan) {
        return null;
    }

    const studioStandardPlanName = UntranslatedPlanNames.StudioStandard;

    return (
        <Group.Item>
            <Text textStyle="body-sm" color="text.medium">
                <Trans>
                    This will be added in addition to your{' '}
                    {studioStandardPlanName} plan
                </Trans>
            </Text>
        </Group.Item>
    );
};

export default AddedToYourStudioPlan;
